<template>
  <div>
    <div
      class=" overflow-y-auto  mt-4"
      ref="messageChat"
      style="max-height: 500px"
    >
      <ul>
        <li
          v-for="(message, idx) in comments"
          :key="idx"
          v-bind:class="{ 'border-t border-green': idx > 0 }"
        >
          <topic-message
            :message="message"
            v-on:remove-message="handleRemoveMessage"
          ></topic-message>
        </li>
      </ul>
    </div>
    <div class="mt-4">
      <form @submit.prevent="onSubmit" v-if="loggedIn">
        <div class=" flex rounded-md shadow-sm relative">
          <picker
            @select="addEmoji"
            title="Pick your emoji"
            emoji="point_up"
            :native="true"
            v-show="showEmojiWindow"
          />
          <textarea
            ref="responseRef"
            v-model="responseInput"
            id="about"
            rows="3"
            @input="$emit('input', $event.target.value)"
            class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          ></textarea>
        </div>
        <div class="mt-2 flex flex-row align-center">
          <span class="inline-flex rounded-md shadow-sm">
            <button
              type="submit"
              class="inline-flex justify-center py-2 px-4 border border-transparent text-xl leading-5 font-medium rounded-md
              tracking-wider
           text-white bg-darkpurple hover:bg-peach focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out font-bebas"
            :disabled="isDisabled"
            >
              Post
            </button>
          </span>
          <span class="inline-flex rounded-md shadow-sm ml-2">
            <button
              type="button"
              class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md
              border border-darkpurple
            bg-white text-darkpurple hover:border-peach hover:text-peach focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
              @click="
                () => {
                  showEmojiWindow = !showEmojiWindow;
                }
              "
            >
              <svg
                class="h-6 w-6 stroke-current"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            </button>
          </span>
        </div>
      </form>
      <if-can-take-part login-class="border border-purple shadow-xl">
        <div></div>
      </if-can-take-part>
    </div>
  </div>
</template>

<script>
import { Picker } from "emoji-mart-vue";
import { auth, firebase, projectCommentsCollection } from "../utils/firebase";
import TopicMessage from "./TopicMessage";
import { mapGetters } from "vuex";
import { removeSessionComment } from "../utils/functions";
import IfCanTakePart from "./IfCanTakePart";
export default {
  name: "SessionCommentArea",
  components: {
    IfCanTakePart,
    Picker,
    TopicMessage
  },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      responseInput: "",
      showEmojiWindow: false,
      unsubscribeFn: null,
      comments: []
    };
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    isDisabled() {
      return this.responseInput === undefined || this.responseInput == null || this.responseInput.trim().length == 0;
    }
  },
  methods: {
    //
    // Fetch Messages
    //
    fetchMessages() {
      this.comments = [];
      this.unsubscribeFn = projectCommentsCollection
        .where("session", "==", this.session._id)
        .orderBy("timestamp", "asc")
        .onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            const doc = change.doc;

            if (change.type === "added") {
              this.comments.push({ id: doc.id, ...doc.data() });
            }
            if (change.type === "modified") {
              const index = this.comments.findIndex(item => item.id === doc.id);
              this.comments.splice(index, 1, { id: doc.id, ...doc.data() });
            }
            if (change.type === "removed") {
              const index = this.comments.findIndex(item => item.id === doc.id);
              this.comments.splice(index, 1);
            }
          });
        });
    },

    //
    // Submit Form
    //
    onSubmit() {
      // TODO: Verification
      projectCommentsCollection
        .add({
          body: this.responseInput,
          user: auth.currentUser.uid,
          userDisplay: auth.currentUser.displayName,
          session: this.session._id,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(() => {
          this.responseInput = "";
        })
        .catch(err => console.error(err));
    },

    //
    // Handle the removal of messages
    //
    handleRemoveMessage(commentID) {
      this.$store.dispatch("setDeletedMessageId", commentID);
      removeSessionComment(commentID);
    },

    //
    // Add an emoji and reset the cursor
    //
    addEmoji(emoji) {
      const textarea = this.$refs.responseRef;
      const cursorPosition = textarea.selectionEnd;
      const start = this.responseInput.substring(0, textarea.selectionStart);
      const end = this.responseInput.substring(textarea.selectionStart);
      const text = start + emoji.native + end;
      // this.$emit('input', text)
      this.responseInput = text;
      textarea.focus();
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.native.length;
      });
      this.showEmojiWindow = false;
    }
  },
  beforeDestroy() {
    if (this.unsubscribeFn) {
      this.unsubscribeFn();
    }
  },
  created() {
    this.fetchMessages();
  }
};
</script>
<style scoped>
.emoji-mart {
  position: absolute;
  top: -400px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
